export const CONTACT_CONFIG = Object.freeze({
  whatsappDisplay: '+90 505 676 76 01',
  whatsappDigits: '905056767601',
  supportEmail: 'support@webouse.com',
  instagramDisplay: '@webouses',
  instagramUrl: 'https://www.instagram.com/webouses',
});

export const getWhatsAppLink = (message = '') => {
  const query = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${CONTACT_CONFIG.whatsappDigits}${query}`;
};

export const getTelephoneLink = () =>
  `tel:+${CONTACT_CONFIG.whatsappDigits}`;

export const getInstagramLink = () =>
  CONTACT_CONFIG.instagramUrl;
